import { Button } from "@mui/material";
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import type { Action } from "@/Constants/actionsList";
import clsx from "clsx";
import { useWrapperLayer } from "@/Common/context/wrapperLayer/WrapperLayerContext";
import { IBasicMenuSlotProps } from "./AnimatedDropdownMenu";
import { MouseEventHandler, useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

export interface INavbarItemProps extends IBasicMenuSlotProps {
	actions: Action[];
	title: string;
}

export default function NavbarItem(props: Readonly<INavbarItemProps>) {
	const { loading } = useSelector((state: RootState) => state.location);
	const { useMultipleAuth } = useAuthorization();
	const isAuthorized = useMultipleAuth(props.actions, "atLeastOne");
	const { isDisabled } = useWrapperLayer();

	const onMouseEnterHandler = useCallback<MouseEventHandler<HTMLDivElement>>((evt) => {
		if (!isAuthorized || isDisabled || loading) {
			if (props.onDisabled) {
				evt.preventDefault();
				props.onDisabled();
			}
			return;
		}
		props.onMouseEnter();
	}, [isAuthorized, isDisabled, props]);

	return (
		<div className="relative h-full" onMouseEnter={onMouseEnterHandler}>
			<Button
				variant="text"
				disabled={!isAuthorized || isDisabled}
				disableFocusRipple
				disableRipple
				className={clsx(
					`!h-full !px-6 !pt-2 !pb-[12.8px] !bg-transparent z-50 !text-[16.2px] !align-middle !capitalize !font-montserrat !text-white`,
					{
						"!opacity-25": !isAuthorized || isDisabled,
						"!cursor-pointer !transition-opacity !duration-[250ms] hover:drop-shadow-subtle-white": !loading,
						"hover:drop-shadow-none !cursor-default !opacity-25": loading,
					}
				)}
			>
				{props.title}
			</Button>
			<div className={"absolute left-1/2 -translate-x-1/2"}>{props.dropdownElement}</div>
		</div>
	);
}
